import classNames from "classnames";
import React from "react";

import AscButton from "../../../AscButton/AscButton";
import { CheckActiveIcon, CrossActiveIcon } from "../../../AscIcons";
import AscGenericCard from "../../AscGenericCard/AscGenericCard";
import styles from "./AscSecondaryCorrectAnswersCard.module.scss";

export interface AscSecondaryCorrectAnswersCardProps {
  className?: string;
  loading?: boolean;
  correct?: boolean;
  showCorrectAnswers?: boolean;
  onAttempt?: () => void;
  onTryAgain?: () => void;
  attemptsCompleted?: boolean;
  attempted?: boolean;
  correctAnswers?: string | string[];
  contentClassName?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  correctAnswersText?: string;
  checkAnswerText?: string;
  tryAgainText?: string;
  incorrectText?: string;
  correctText?: string;
  shouldGoNext?: boolean;
  onNext?: () => void;
}

export default function AscSecondaryCorrectAnswersCard({
  className,
  loading,
  onAttempt,
  correct,
  attemptsCompleted,
  attempted,
  correctAnswers,
  fullWidth = true,
  disabled,
  correctAnswersText = "Correct answers",
  checkAnswerText = "Submit",
  tryAgainText = "Try Again",
  incorrectText = "Incorrect",
  correctText = "Correct",
  showCorrectAnswers,
  onTryAgain,
  shouldGoNext,
  onNext,
}: AscSecondaryCorrectAnswersCardProps) {
  function handleActionButtonClick() {
    if (showCorrectAnswers && onTryAgain) {
      onTryAgain();
      return;
    }

    if (shouldGoNext && onNext) {
      onNext();
      return;
    }

    onAttempt?.();
  }

  return (
    <AscGenericCard
      title={null}
      loading={loading}
      coverImageUrl={null}
      data-testid="asc-secondary-correct-answers-card"
      className={classNames(
        styles.ground,
        {
          [styles.fullWidth]: fullWidth,
          [styles.correct]: showCorrectAnswers && correct === true,
          [styles.incorrect]: showCorrectAnswers && correct === false,
        },
        className
      )}
      bodyClassName={styles.cardBody}
      contentClassName={styles.content}
    >
      <div className={classNames(styles.badge)}>
        {correct ? (
          <CheckActiveIcon className={styles.icon} />
        ) : (
          <CrossActiveIcon className={styles.icon} />
        )}
        <div className={styles.textContainer}>
          <div className={styles.title}>
            {correct ? correctText : incorrectText}
          </div>
          {showCorrectAnswers && correctAnswers?.length ? (
            <div className={styles.correctAnswers}>
              {correctAnswersText}
              {": "}
              {Array.isArray(correctAnswers) ? (
                <>
                  <br />
                  {correctAnswers?.map((answer, index) => (
                    <React.Fragment key={index}>
                      {answer}
                      <br />
                    </React.Fragment>
                  ))}
                </>
              ) : (
                correctAnswers
              )}
            </div>
          ) : null}
        </div>
      </div>

      {attemptsCompleted ? null : (
        <AscButton
          disabled={attemptsCompleted || disabled}
          onClick={handleActionButtonClick}
          className={styles.actionButton}
          size="large"
        >
          {showCorrectAnswers ? tryAgainText : checkAnswerText}
        </AscButton>
      )}
    </AscGenericCard>
  );
}
